import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import WinnerCard from "../../../../common/WinnerCard/WinnerCard";
import LoadingWheel from "../../../../common/LoadingWheel";
import Bubble from "../../../../common/Bubble";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../common/Context";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { text } from "../../../../../theme/colours";
import { CHALLENGES_WINNER_AREA } from "../../../../../constants/ids";

const PreviousWinners = ({ winnersData, type = "campaign" }) => {
  const { t } = useTranslation("CompetitionInfo");
  const { mobileView, tabletView, desktopView } = useContext(GlobalContext);

  const [currCampBubble, setCurrCampBubble] = useState(0);
  const [currWinBubble, setCurrWinBubble] = useState(0);
  const [activeWinDataSlice, setActiveWinDataSlice] = useState();
  const [totWinBubble, setTotWinBubble] = useState();
  const [emptyWinnerFlag, setEmptyWinnerFlag] = useState(false);

  const numOfBubbles = Math.ceil(winnersData?.length / 4);

  const handleBubbleNav = (type, comp) => {
    if (comp === "camp") {
      if (type === "left" && currCampBubble !== 0) {
        setCurrCampBubble(currCampBubble - 1);
      }
      if (type === "right" && currCampBubble !== numOfBubbles - 1) {
        setCurrCampBubble(currCampBubble + 1);
      }
    } else {
      if (type === "left" && currWinBubble !== 0) {
        setCurrWinBubble(currWinBubble - 1);
      }
      if (type === "right" && currWinBubble !== totWinBubble - 1) {
        setCurrWinBubble(currWinBubble + 1);
      }
    }
  };

  useEffect(() => {
    const setSlice = () => {
      let temp = winnersData.length / 4;
      (temp % 4) % 1 === 0
        ? setTotWinBubble(temp)
        : setTotWinBubble(Math.floor(temp) + 1);
      setActiveWinDataSlice(winnersData.slice(0, 4));
    };
    winnersData?.length < 1 && setEmptyWinnerFlag(true);
    winnersData && setSlice();
  }, [winnersData]);

  useEffect(() => {
    winnersData &&
      setActiveWinDataSlice(
        winnersData.slice(currWinBubble * 4, currWinBubble * 4 + 4),
      );
  }, [currWinBubble]);

  const accordionStyle = {
    m: "0 !important",
    p: "0.5rem 0",
    "&::before": {
      opacity: desktopView ? "1 !important" : "0 !important",
    },
    "& > div:first-child": { minHeight: "auto" },
    backgroundColor: "transparent",
    borderBottom: !desktopView && "1px solid #C1C0C3",
    borderRadius: "0 !important",
    color: text.primary,
  };
  const accTitleStyle = { px: 0, "& div": { m: "0.75rem 0 !important" } };
  const titleStyle = { fontSize: desktopView ? "1.5rem" : "1rem" };
  const winnerAreaStyle = {
    p: "0.5rem",
    display: "flex",
    flexWrap: mobileView || tabletView ? "wrap" : "no-wrap",
    width: "100%",
    mb: "0.5rem",
    justifyContent: !activeWinDataSlice?.length && "center",
  };
  const navStyle = {
    width: "100%",
    height: "15%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const leftWinArrowStyle = {
    color: text.primary,
    opacity: currWinBubble === 0 ? "50%" : "100%",
    mr: "0.25rem",
  };
  const rightWinArrowStyle = {
    ...leftWinArrowStyle,
    opacity: currWinBubble === totWinBubble - 1 ? "50%" : "100%",
  };
  const noCampBoxStyle = {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignContent: "center",
    textAlign: "center",
    height: "100%",
    backgroundColor:
      "linear-gradient(rgb(255, 255, 255) 0%, rgb(244, 242, 248) 100%)",
  };
  const emptyTextStyle = {
    fontWeight: 500,
  };

  return (
    <Accordion sx={accordionStyle}>
      <AccordionSummary
        sx={accTitleStyle}
        expandIcon={<ExpandMoreIcon sx={{ color: text.primary }} />}>
        <Typography variant="h2" sx={titleStyle}>
          {t("winnersTitle")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={winnerAreaStyle} id={CHALLENGES_WINNER_AREA(type)}>
          {winnersData ? (
            <>
              {activeWinDataSlice?.length > 0 ? (
                activeWinDataSlice.map((winner) => (
                  <>
                    <WinnerCard winnerData={winner} campaignType={type} />
                  </>
                ))
              ) : (
                <Box sx={noCampBoxStyle}>
                  <Typography variant="h3" sx={emptyTextStyle}>
                    {t("EmptyWinTitle")}
                  </Typography>
                  <Typography variant="body1" sx={emptyTextStyle}>
                    {t("EmptyWinDescription")}
                  </Typography>
                </Box>
              )}
            </>
          ) : (
            <LoadingWheel width={3} />
          )}
        </Box>
        {totWinBubble && winnersData?.length > 4 && !emptyWinnerFlag ? (
          <Box sx={navStyle}>
            <KeyboardArrowLeftIcon
              sx={leftWinArrowStyle}
              onClick={() => handleBubbleNav("left", "win")}
            />
            {Array.from({ length: totWinBubble }, (_, index) => (
              <Bubble
                key={index}
                radius="0.5rem"
                currBubble={currWinBubble}
                setCurrBubble={setCurrWinBubble}
                i={index}
              />
            ))}
            <KeyboardArrowRightIcon
              sx={rightWinArrowStyle}
              onClick={() => handleBubbleNav("right", "win")}
            />
          </Box>
        ) : null}
      </AccordionDetails>
    </Accordion>
  );
};

export default PreviousWinners;
